import React, { Component } from 'react'
import { OverlayTrigger, Popover, Tooltip, Button, Modal, Col } from 'react-bootstrap'
import Subsidiary from '../../features/PageCompany/Components/Subsidiaries/cardItem'
import Propiedad from '../Sections/Propiedades/PropiedadesList/propiedad'
import Btn from '../Buttons'
import FormContact from '../../features/commons/ContactForm/ContactForm.container'
import { Link } from 'react-router'
import Scroll from 'react-scroll';
import { DIST_URL } from '../../constants/api';

export default class MyMark extends Component {

  constructor (props) {
    super(props)

    this.state = {
      showModal: false
    }
    this.changeViewModal = this.changeViewModal.bind(this)
  }

  changeViewModal() {
    this.setState({showModal: !this.state.showModal })
    this.refs.overlay.hide();
  }

  scrollToContactForm(){
    var scroller = Scroll.scroller;
    scroller.scrollTo('ContactForm', {
      duration: 1500,
      delay: 100,
      smooth: true,
    })
  }

  createTooltip(name) {
    return (<Tooltip id="tooltip-property"><p>{name}</p></Tooltip>)
  }

  _renderCategory (id, categories) {
    let category = categories.filter(function (c) {
      return parseInt(c.id) === id;
    });
    return category = (category.length > 0) ? category[0].name : ''
  }

  render () {

    let categories = this.props.categories
  	let item = this.props.item;
  	let img = item.image;
    let subsidiary = item.id
    let type = this.props.type;
    let location = ''
    let amount, price, priceClass = ''
    let street = ''
    let generals = [] //array of summary of caracteristics

    if (item.property_code !== undefined){
      location = item.neighborhood.name ? (item.neighborhood.name + ', ' + item.neighborhood.province).toLowerCase() : item.neighborhood.district.toLowerCase()
      street = item.address.toLowerCase()
      amount = (item.operation_type.name === 'Alquiler') ? item.rental_currency.name + ' ' + (parseInt(item.rental_amount)).toLocaleString('de-DE'): item.sale_currency.name + ' ' + (parseInt(item.sale_amount)).toLocaleString('de-DE')
      price = (item.property_type.id === 500000000000021 || !item.web_price) ? 'Consultar Precio' : amount
      priceClass = (item.property_type.id === 500000000000021 || !item.web_price) ? 'no-price-box' : ''

      switch (item.property_type.id) {
        case 11 : //housee
          generals = [{value: item.bedrooms, img: DIST_URL+'/assets/images/icons-results/bed.png', overlay: this.createTooltip('Dormitorios')},
                      {value: item.ambients, img: DIST_URL+'/assets/images/icons-results/ambients.png', overlay: this.createTooltip('Ambientes')},
                      {value: ((parseInt(item.land_area)).toLocaleString('de-DE') + 'm2'), img: DIST_URL+'/assets/images/icons-results/ST.png', overlay: this.createTooltip('Superficie Terreno')},
                      {value: ((parseInt(item.covered_area)).toLocaleString('de-DE') + 'm2'), img: DIST_URL+'/assets/images/icons-results/SC.png', overlay: this.createTooltip('Superficie Cubierta')}]
          break;
        case 15 : //apartment
          generals = [{value: item.bedrooms, img: DIST_URL+'/assets/images/icons-results/bed.png', overlay: this.createTooltip('Dormitorios')},
                      {value: item.ambients, img: DIST_URL+'/assets/images/icons-results/ambients.png', overlay: this.createTooltip('Ambientes')},
                      {value: item.garages, img: DIST_URL+'/assets/images/icons-results/garage.png', overlay: this.createTooltip('Estacionamiento')},
                      {value: ((parseInt(item.covered_area)).toLocaleString('de-DE') + 'm2'), img: DIST_URL+'/assets/images/icons-results/SC.png', overlay: this.createTooltip('Superficie Cubierta')}]
          break;
        case 6 : //terreno
          generals = [{value: ((parseInt(item.land_area)).toLocaleString('de-DE') + 'm2'), img: DIST_URL+'/assets/images/icons-results/ST.png', overlay: this.createTooltip('Superficie Terreno')},
                      {value: item.orientation, img: DIST_URL+'/assets/images/icons-results/orientacion.png', overlay: this.createTooltip('Orientación')}]
          break;

        case 7 : //industry
          generals = [{value: ((parseInt(item.covered_area)).toLocaleString('de-DE') + 'm2'), img: DIST_URL+'/assets/images/icons-results/SC.png', overlay: this.createTooltip('Superficie Cubierta')},
                      {value: ((parseInt(item.land_area)).toLocaleString('de-DE') + 'm2'), img: DIST_URL+'/assets/images/icons-results/ST.png', overlay: this.createTooltip('Superficie Terreno')},
                      {value: item.nave ? parseInt(item.nave) : 0, img: DIST_URL+'/assets/images/icons-results/N.png', overlay: this.createTooltip('Cantidad de Naves')}]
          break;

        case 500000000000021 : //fields
          let hc = (item.land_area) ? item.land_area/10000 : 0
          generals = [{value: parseInt(hc), img: DIST_URL+'/assets/images/icons-results/H.png', overlay: this.createTooltip('Hectáreas')},
                      {value: item.aptitude.name , img: DIST_URL+'/assets/images/icons-results/aptitud.png', overlay: this.createTooltip('Aptitud')}
                      ]
          break;

        case 5 : //retail
          generals = [{value: ((parseInt(item.covered_area)).toLocaleString('de-DE') + 'm2'), img: DIST_URL+'/assets/images/icons-results/SC.png', overlay: this.createTooltip('Superficie Cubierta')}]
          break;

        case 4: case 8: //office/buildings
          generals = [{value: categories ? (this._renderCategory(item.category, categories)) : '' , img: DIST_URL+'/assets/images/icons-results/categoria.png', overlay: this.createTooltip('Categoría')},
                      {value: item.garages, img: DIST_URL+'/assets/images/icons-results/garage.png', overlay: this.createTooltip('Estacionamiento')},
                      {value: ((parseInt(item.covered_area)).toLocaleString('de-DE') + 'm2'), img: DIST_URL+'/assets/images/icons-results/SC.png', overlay: this.createTooltip('Superficie Cubierta')}]
          break;
      }
    }

   	var style = {
      width: 359,
      height: 370,
      maxWidth: 359,
      display: "flex",
    	justifyContent: "center",
    	padding: 0,
      borderRadius: 0,
      border: "transparent",
    }

    var styleSubsidiary = {
      zIndex: 5,
      width: 391,
      maxWidth: 391,
      display: "flex",
      justifyContent: "center",
      padding: 0,
      paddingBottom: 30,
      borderRadius: 0,
      border: "transparent",
    }

    var styleDetail = {
      width: 197,
      height: '100%',
      maxWidth: 197,
      maxHeight: 300,
      display: "flex",
      justifyContent: "center",
      padding: 0,
      borderRadius: 0,
      border: 0
    }

    var styleDetailXs = {
      width: 208,
      height: '100%',
      maxWidth: 197,
      display: "flex",
      justifyContent: "center",
      padding: 15,
      borderRadius: 0,
      border: 0
    }

  	const popoverSubsidiary = (
		  <Popover id="popover-positioned-top" style={styleSubsidiary}>
		  	<div className="popover-img">
		  		<img src={img} alt="LJRamos" />
		  	</div>
		  	<div className="pop-info">
		  		<Subsidiary item={item} />
          <span className="contact-btn">
            <a onClick={(e) => e.stopPropagation()} target='_blank' href={`https://api.whatsapp.com/send?phone=54911${(item && item.telefono && item.telefono.replace(/\D+/g, "")) || '41141000'}`}>
              <div className="contact-item whatsapp">
                  <i className="fa fa-whatsapp"></i><h3>Whatsapp</h3>
              </div>
            </a>
            <Btn text="Contacto" classes="btn-popover" clickButton={() => this.changeViewModal()} />
          </span>
		  	</div>
		  </Popover>
		);

    const popoverDetail = (
      <Popover id="popover-detail" style={styleDetail}>
        <Link to={'/' + item.property_code}>
          <div className="popover-img">
            <img src={img !== undefined ? img : DIST_URL+'/assets/images/placeholder-popover.png' } alt="LJRamos" />
          </div>
        </Link>
        <div className="pop-info pop-detail">
          <div className="item-sucursal">
            <Link to={'/' + item.property_code}><h1>{street}</h1></Link>
            <div className="items-detail">
              <i className="fa fa-map-marker"></i>
              <small>{location}</small>
            </div>
            <div className="items-detail">
              <h3 className={priceClass}>{price}</h3>
            </div>
            <div className="box-details">
              {generals.map((item, index) =>
                ((item.value !== 0) && (item.value !== undefined)) ? (
                  <div className="item-box" key={index}>
                    <p>{item.value}</p>
                    <OverlayTrigger placement="bottom" overlay={item.overlay}>
                      <Button className="btn-fake"><img src={item.img} alt="LJRamos" /></Button>
                    </OverlayTrigger>
                  </div>
                ) : ''
              )}
            </div>
          </div>
          <Btn text="Contacto" classes="btn-popover hidden-xs" clickButton={() => this.scrollToContactForm()} />
          <Btn text="Contacto" classes="btn-popover visible-xs" clickButton={() => this.changeViewModal()} />
        </div>
      </Popover>
    );

    const popoverDetailMapList = (
      <Popover id="popover-detail" style={styleDetail}>
        <Link to={'/' + item.property_code}>
          <div className="popover-img">
            <img src={img !== undefined ? img : DIST_URL+'/assets/images/placeholder-popover.png' } alt="LJRamos" />
          </div>
        </Link>
        <div className="pop-info pop-detail">
          <div className="item-sucursal">
            <Link to={'/' + item.property_code}><h1>{street}</h1></Link>
            <div className="items-detail">
              <i className="fa fa-map-marker"></i>
              <small>{location}</small>
            </div>
            <div className="items-detail">
              <h3 className={priceClass}>{price}</h3>
            </div>
            <div className="box-details">
              {generals.map((item, index) =>
                ((item.value !== 0) && (item.value !== undefined)) ? (
                  <div className="item-box" key={index}>
                    <p>{item.value}</p>
                    <OverlayTrigger placement="bottom" overlay={item.overlay}>
                      <Button className="btn-fake"><img src={item.img} alt="LJRamos" /></Button>
                    </OverlayTrigger>
                  </div>
                ) : ''
              )}
            </div>
          </div>
          <Btn text="Contacto" classes="btn-popover" clickButton={() => this.changeViewModal()} />
        </div>
      </Popover>
    );

    const popoverDetailXs = (
      <Popover id="popover-detail-xs" style={styleDetailXs}>
        <Link to={'/' + item.property_code}>
          <div className="popover-img">
            <img src={img !== undefined ? img : DIST_URL+'/assets/images/placeholder-popover.png' } alt="LJRamos" />
          </div>
        </Link>
        <div className="pop-info pop-detail">
          <div className="item-sucursal">
            <Link to={'/' + item.property_code}><h1>{street}</h1></Link>
            <div className="items-detail">
              <i className="fa fa-map-marker"></i>
              <small>{location}</small>
            </div>
          </div>
        </div>
      </Popover>
    );

    let placement = 'top'

    let markerStyle = {
      position: "absolute",
      top: "-53px",
      right: "-17.5px"
    }

    if (type === 'sucursal'){
      return (
        <div>
          <OverlayTrigger trigger="click" shouldUpdatePosition={true} rootClose placement="left" overlay={popoverSubsidiary}>
            <img style={markerStyle} src={DIST_URL+'/assets/images/maps-mark.png'} alt="LJRamos" />
          </OverlayTrigger>
          <Modal
            className="modal-contact-form"
            show={this.state.showModal}
            onHide={(e) => this.changeViewModal(e)}
            aria-labelledby="contained-modal-title"
            bsSize="large"
          >
            <Modal.Body>
              <div className="form-box">
                <div className="form-content form-slider">
                  <Col md={12} sm={12} className="inputs-form form-modal hidden-xs">
                    <FormContact textareaDefault={false} subsidiary={subsidiary} />
                  </Col>
                  <div className="col-md-12 inputs-form visible-xs">
                    <FormContact textareaDefault={false} subsidiary={subsidiary} />
                  </div>
                </div>
                <div className="box-close">
                  <Btn type="submit" clickButton={() => this.changeViewModal()} className="btn-close">
                    <i className="fa fa-times fa-lg"></i>
                  </Btn>
                </div>
              </div>
            </Modal.Body>
          </Modal>
        </div>
      )
    }
    else{
      if (type === 'propiedad'){
        return (
          <OverlayTrigger shouldUpdatePosition={true} trigger="click" rootClose placement={placement} overlay={popoverDetail}>
            <img style={markerStyle}  src={DIST_URL+'/assets/images/maps-mark.png'} alt="LJRamos" />
          </OverlayTrigger>
        )
      }
      if (type === 'PropiedadesMapList'){
        return (
          <div>
            <OverlayTrigger ref="overlay" shouldUpdatePosition={true} trigger="click" rootClose placement={placement} overlay={popoverDetailMapList}>
              <img style={markerStyle}  src={DIST_URL+'/assets/images/maps-mark.png'} alt="LJRamos" />
            </OverlayTrigger>
            <Modal
              className="modal-contact-form"
              show={this.state.showModal}
              onHide={(e) => this.changeViewModal(e)}
              aria-labelledby="contained-modal-title"
              bsSize="large"
            >
              <Modal.Body>
                <div className="form-box">
                  <div className="form-content form-slider">
                    <Col md={12} sm={12} className="inputs-form form-modal hidden-xs">
                      <FormContact textareaDefault={false} subsidiary={subsidiary} />
                    </Col>
                    <div className="col-md-12 inputs-form visible-xs">
                      <FormContact textareaDefault={false} subsidiary={subsidiary} />
                    </div>
                  </div>
                  <div className="box-close">
                    <Btn type="submit" clickButton={() => this.changeViewModal()} className="btn-close">
                      <i className="fa fa-times fa-lg"></i>
                    </Btn>
                  </div>
                </div>
              </Modal.Body>
            </Modal>
          </div>
        )
      }
      else{
        if (type === 'detail-xs'){
          return (
            <OverlayTrigger shouldUpdatePosition={true} trigger="click" rootClose placement="top" overlay={popoverDetailXs}>
              <img style={markerStyle} src={DIST_URL+'/assets/images/maps-mark.png'} alt="LJRamos" />
            </OverlayTrigger>
          )
        }
        else{
          return (
            <div>
              <OverlayTrigger shouldUpdatePosition={true} trigger="click" rootClose placement="top" overlay={popoverDetail}>
                <img style={markerStyle} src={DIST_URL+'/assets/images/maps-mark.png'} alt="LJRamos" />
              </OverlayTrigger>
              <Modal
                className="modal-contact-form"
                show={this.state.showModal}
                onHide={(e) => this.changeViewModal(e)}
                aria-labelledby="contained-modal-title"
                bsSize="large"
              >
              <Modal.Body>
                <div className="form-box">
                  <div className="form-content form-slider">
                    <div className="col-md-12 inputs-form visible-xs">
                      <FormContact property={item} />
                    </div>
                  </div>
                  <div className="box-close">
                    <Btn type="submit" clickButton={() => this.changeViewModal()} className="btn-close">
                      <i className="fa fa-times fa-lg"></i>
                    </Btn>
                  </div>
                </div>
              </Modal.Body>
              </Modal>
            </div>
          )
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Maps/mark.js